export const createLatLngObject = (latLng, returnStringObject = false) => {
    if (typeof latLng === 'object' &&
        !Array.isArray(latLng) &&
        latLng !== null) {
        // console.log("Inside obj ceater", latLng)
        return latLng;
    }

    if (latLng?.includes(",") || latLng?.indexOf(",")) {
        const latLngArray = latLng.split(",");
        if (!returnStringObject) {
            return {
                lat: parseFloat(latLngArray[0]),
                lng: parseFloat(latLngArray[1])
            };
        } else {
            return {
                lat: latLngArray[0],
                lng: latLngArray[1]
            };
        }
    }
    else {
        return;
    }

};


export function calculateBearing(origin, destination) {
    const lat1 = origin.lat() * Math.PI / 180;
    const lon1 = origin.lng() * Math.PI / 180;
    const lat2 = destination.lat() * Math.PI / 180;
    const lon2 = destination.lng() * Math.PI / 180;

    const dLon = lon2 - lon1;
    const y = Math.sin(dLon) * Math.cos(lat2);
    const x = Math.cos(lat1) * Math.sin(lat2) - Math.sin(lat1) * Math.cos(lat2) * Math.cos(dLon);
    const brng = Math.atan2(y, x) * 180 / Math.PI;

    return (brng + 360) % 360;  // Normalize the bearing to 0-360 degrees
}


export function formatDateAndTime(date_string) {
    const date_obj = new Date(date_string);
    const optionsDate = { day: '2-digit', month: 'short', year: 'numeric' };
    const optionsTime = { hour: '2-digit', minute: '2-digit', hour12: false };

    const formattedDate = date_obj.toLocaleDateString('en-GB', optionsDate); // '17 Oct 2024'
    const formattedTime = date_obj.toLocaleTimeString('en-GB', optionsTime); // '01:03'

    return `${formattedDate} | ${formattedTime}`;
}


export function getAddressObject(shipping_address, billing_address) {
    let addressObject = {
        "first_name": "",
        "address1": "",
        "phone": "",
        "city": "",
        "zip": "",
        "province": "",
        "country": "",
        "last_name": "",
        "address2": "",
        "company": "",
        "latitude": "",
        "longitude": "",
        "name": "",
        "country_code": "",
        "province_code": ""
    }
    if (shipping_address?.first_name) {
        addressObject.first_name = shipping_address?.first_name;
    } else if (billing_address?.first_name) {
        addressObject.first_name = billing_address?.first_name;
    }
    if (shipping_address?.address1 || shipping_address?.address_1) {
        addressObject.address1 = shipping_address?.address1 || shipping_address?.address_1;
    } else if (billing_address?.address1 || shipping_address?.address_1) {
        addressObject.address1 = billing_address?.address1 || shipping_address?.address_1;
    }
    if (shipping_address?.phone) {
        addressObject.phone = shipping_address?.phone;
    } else if (billing_address?.phone) {
        addressObject.phone = billing_address?.phone;
    }
    if (shipping_address?.city) {
        addressObject.city = shipping_address?.city;
    } else if (billing_address?.city) {
        addressObject.city = billing_address?.city;
    }

    if (shipping_address?.zip) {
        addressObject.zip = shipping_address?.zip;
    } else if (billing_address?.zip) {
        addressObject.zip = billing_address?.zip;
    }
    if (shipping_address?.province) {
        addressObject.province = shipping_address?.province;
    } else if (billing_address?.province) {
        addressObject.province = billing_address?.province;
    }
    if (shipping_address?.country) {
        addressObject.country = shipping_address?.country;
    } else if (billing_address?.country) {
        addressObject.country = billing_address?.country;
    }
    if (shipping_address?.last_name) {
        addressObject.last_name = shipping_address?.last_name;
    } else if (billing_address?.last_name) {
        addressObject.last_name = billing_address?.last_name;
    }
    if (shipping_address?.address2 || shipping_address?.address_2) {
        addressObject.address2 = shipping_address?.address2 || shipping_address?.address_2;
    } else if (billing_address?.address2 || shipping_address?.address_2) {
        addressObject.address2 = billing_address?.address2 || shipping_address?.address_2;
    }
    if (shipping_address?.company) {
        addressObject.company = shipping_address?.company;
    } else if (billing_address?.company) {
        addressObject.company = billing_address?.company;
    }
    if (shipping_address?.latitude) {
        addressObject.latitude = shipping_address?.latitude;
    } else if (billing_address?.latitude) {
        addressObject.latitude = billing_address?.latitude;
    }
    if (shipping_address?.longitude) {
        addressObject.longitude = shipping_address?.longitude;
    } else if (billing_address?.longitude) {
        addressObject.longitude = billing_address?.longitude;
    }
    if (shipping_address?.name) {
        addressObject.name = shipping_address?.name;
    } else if (billing_address?.name) {
        addressObject.name = billing_address?.name;
    }
    if (shipping_address?.country_code) {
        addressObject.country_code = shipping_address?.country_code;
    } else if (billing_address?.country_code) {
        addressObject.country_code = billing_address?.country_code;
    }
    if (shipping_address?.province_code) {
        addressObject.province_code = shipping_address?.province_code;
    } else if (billing_address?.province_code) {
        addressObject.province_code = billing_address?.province_code;
    }

    return (addressObject);
}

export const makeAddressString = (address) => {
    let name = (address?.name) || ((address?.first_name) + ' ' + (address?.last_name));
    let addressLine1 = '';
    let addressLine2 = '';
    let addressLine3 = '';

    if (address?.address1) {
        addressLine1 = address?.address1;
    }
    if (address?.address2) {
        addressLine2 = address?.address2;
    }
    if (address?.city) {
        addressLine3 = address?.city;
    }
    if (address?.province) {
        addressLine3 = (addressLine3 + ', ' + (address?.province));
    }
    if (address?.zip) {
        addressLine3 = (addressLine3 + ', ' + (address?.zip));
    }
    if (address?.country) {
        addressLine3 = (addressLine3 + ', ' + (address?.country));
    }
    // console.log({ name }, { addressLine1 }, { addressLine2 }, { addressLine3 })
    let formattedAddress = { name, addressLine1, addressLine2, addressLine3 }

    return (formattedAddress);
}

export const makeAddressPara = (address) => {
    let addStr = '';
    if ((address?.address1) || (address?.address_1)) {
        addStr = (address?.address1 || (address?.address_1));
    }
    if ((address?.address2) || (address?.address_2)) {
        addStr = (addStr + ', ' + (address?.address2 || (address?.address_2)));
    }
    if (address?.city) {
        addStr = (addStr + ', ' + (address?.city));
    }
    if (address?.province) {
        addStr = (addStr + ', ' + (address?.province));
    }
    if (address?.zip) {
        addStr = (addStr + ', ' + (address?.zip));
    }
    if (address?.country) {
        addStr = (addStr + ', ' + (address?.country));
    }
    return (addStr);
}


export function removeUnderscore(str) {
    let treatedStr = '';
    if (typeof str === 'string' || str instanceof String) {
        treatedStr = str.split("_").join(" ");
        return (treatedStr);
    }
    else { return (str) }
}

export const DELIVERY_STATUS = {
    NEW: 'NEW',
    PICKED_UP: 'PICKED_UP',
    OUT_FOR_DELIVERY: 'OUT_FOR_DELIVERY',
    RESCHEDULE: 'RESCHEDULE',
    DELIVERED: 'DELIVERED',
    PARTIAL_DELIVERED: 'PARTIAL_DELIVERED',
    CANCELLED: 'CANCELLED'
}

// Nested keys a shipment endpoint can hide its coordinates behind. `display` is
// the normalised shape the API attaches; a warehouse carries them on the
// populated `shipment_location.geo_cordinates` ref, a customer address inline on
// `order_location`.
const LOCATION_SOURCE_KEYS = ['display', 'geo_cordinates', 'shipment_location', 'order_location', 'location'];

/**
 * Pulls a { lat, lng } pair out of any of the shapes the tracking API uses for a
 * shipment endpoint - inline "lat"/"lng" strings, a "latLng" string,
 * latitude/longitude, or any of those nested under LOCATION_SOURCE_KEYS. Pass
 * the whole `start_location` / `end_location` object and it finds them.
 * Returns undefined when the location carries no usable coordinates.
 * @param {object} location
 * @param {number} depth internal - guards against a self referencing payload
 * @returns {{lat: number, lng: number} | undefined}
 */
export const extractLatLng = (location, depth = 0) => {
    if (!location || typeof location !== 'object' || depth > 3) {
        return undefined;
    }

    let lat = parseFloat(location?.lat ?? location?.latitude);
    let lng = parseFloat(location?.lng ?? location?.longitude);

    if ((!lat || !lng) && (typeof location?.latLng === 'string')) {
        const coordinates = createLatLngObject(location?.latLng);
        lat = coordinates?.lat;
        lng = coordinates?.lng;
    }

    if (lat && lng) {
        return { lat, lng };
    }

    for (const sourceKey of LOCATION_SOURCE_KEYS) {
        const nestedCoordinates = extractLatLng(location[sourceKey], (depth + 1));
        if (nestedCoordinates) {
            return nestedCoordinates;
        }
    }

    return undefined;
}

/**
 * Name of a shipment endpoint, e.g. the warehouse the driver picks the order up
 * from. Same precedence as extractLatLng, so the title matches the pin.
 * @param {object} location
 * @returns {string}
 */
export const extractLocationTitle = (location) => {
    return ((location?.display?.title)
        || (location?.shipment_location?.title)
        || (location?.order_location?.title)
        || '');
}

// Statuses where a driver is already attached to the shipment, so their live
// location is worth showing: heading to the store, then heading to the customer.
export const LIVE_LOCATION_STATUS = [
    DELIVERY_STATUS.NEW,
    DELIVERY_STATUS.PICKED_UP,
    DELIVERY_STATUS.OUT_FOR_DELIVERY
]

// Statuses where the driver is still on their way to our store.
export const PICKUP_STATUS = [
    DELIVERY_STATUS.NEW,
    DELIVERY_STATUS.PICKED_UP
]

// Who the driver is currently driving towards, i.e. what the map routes to.
export const ROUTE_TARGET = {
    WAREHOUSE: 'WAREHOUSE',
    CUSTOMER: 'CUSTOMER'
}
